import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@frontend/unhideschool/env';

@Pipe({ name: 'transformImage'})
 export class TransformImagePipe implements PipeTransform {

  transform(iconName: string): string {
    return `${environment.cdnUrl}/course-list/${iconName}.svg`;
   }
 }